import { render, staticRenderFns } from "./IcySilverSwitchProV3.vue?vue&type=template&id=cc40681c&scoped=true"
import script from "./IcySilverSwitchProV3.vue?vue&type=script&lang=ts"
export * from "./IcySilverSwitchProV3.vue?vue&type=script&lang=ts"
import style0 from "./IcySilverSwitchProV3.vue?vue&type=style&index=0&id=cc40681c&prod&lang=scss&scoped=true"
import style1 from "./IcySilverSwitchProV3.vue?vue&type=style&index=1&id=cc40681c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc40681c",
  null
  
)

export default component.exports